import { render, staticRenderFns } from "./insufficient-funds.vue?vue&type=template&id=31fbe73f&scoped=true&"
import script from "./insufficient-funds.vue?vue&type=script&lang=js&"
export * from "./insufficient-funds.vue?vue&type=script&lang=js&"
import style0 from "./insufficient-funds.vue?vue&type=style&index=0&id=31fbe73f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbe73f",
  null
  
)

export default component.exports